import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, clearCsrfToken } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/errors";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      clearCsrfToken();
      // V5-H2 (HIS-009, D-H2): sign-out clears client-side Copilot context (session pointer, owner, pending card state);
      // server-side history is preserved and re-authorized on the next login.
      try {
        Object.keys(sessionStorage).filter((k) => k.startsWith("zelligio-copilot")).forEach((k) => sessionStorage.removeItem(k));
        Object.keys(localStorage).filter((k) => k.startsWith("zelligio-copilot")).forEach((k) => localStorage.removeItem(k));
      } catch { /* storage unavailable */ }
      setUser(null);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
